/**
 * @fileoverview gRPC-Web generated client stub for mlmbox.client.asset_pair.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.15.8
// source: mlmbox/client/asset_pair/v1/asset_pair.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var mlmbox_type_asset_pair_pb = require('../../../../mlmbox/type/asset_pair_pb.js')

var mlmbox_type_exchanger_pb = require('../../../../mlmbox/type/exchanger_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.mlmbox = {};
proto.mlmbox.client = {};
proto.mlmbox.client.asset_pair = {};
proto.mlmbox.client.asset_pair.v1 = require('./asset_pair_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.asset_pair.v1.AssetPairClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.asset_pair.v1.AssetPairPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.type.AssetPair.ID,
 *   !proto.mlmbox.type.Exchanger.Rate>}
 */
const methodDescriptor_AssetPair_Get = new grpc.web.MethodDescriptor(
  '/mlmbox.client.asset_pair.v1.AssetPair/Get',
  grpc.web.MethodType.UNARY,
  mlmbox_type_asset_pair_pb.AssetPair.ID,
  mlmbox_type_exchanger_pb.Exchanger.Rate,
  /**
   * @param {!proto.mlmbox.type.AssetPair.ID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_exchanger_pb.Exchanger.Rate.deserializeBinary
);


/**
 * @param {!proto.mlmbox.type.AssetPair.ID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.Exchanger.Rate)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Exchanger.Rate>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.asset_pair.v1.AssetPairClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.asset_pair.v1.AssetPair/Get',
      request,
      metadata || {},
      methodDescriptor_AssetPair_Get,
      callback);
};


/**
 * @param {!proto.mlmbox.type.AssetPair.ID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.Exchanger.Rate>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.asset_pair.v1.AssetPairPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.asset_pair.v1.AssetPair/Get',
      request,
      metadata || {},
      methodDescriptor_AssetPair_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.mlmbox.type.Exchanger.Rate>}
 */
const methodDescriptor_AssetPair_All = new grpc.web.MethodDescriptor(
  '/mlmbox.client.asset_pair.v1.AssetPair/All',
  grpc.web.MethodType.SERVER_STREAMING,
  google_protobuf_empty_pb.Empty,
  mlmbox_type_exchanger_pb.Exchanger.Rate,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_exchanger_pb.Exchanger.Rate.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Exchanger.Rate>}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.asset_pair.v1.AssetPairClient.prototype.all =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/mlmbox.client.asset_pair.v1.AssetPair/All',
      request,
      metadata || {},
      methodDescriptor_AssetPair_All);
};


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Exchanger.Rate>}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.asset_pair.v1.AssetPairPromiseClient.prototype.all =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/mlmbox.client.asset_pair.v1.AssetPair/All',
      request,
      metadata || {},
      methodDescriptor_AssetPair_All);
};


module.exports = proto.mlmbox.client.asset_pair.v1;

